import {
  FETCH_PROPOSAL,
  FETCH_PROPOSAL_FULFILLED,
  FETCH_PROPOSAL_PENDING,
  FETCH_PROPOSAL_REJECTED,

  LOG_OUT
} from '../constants/ActionTypes';



const initialState =  { data : [], type : null, fetched: false, fetching: false }   

const proposals = (state = initialState, action) => {      
  switch (action.type) {
    case FETCH_PROPOSAL:{                                             
        state = {...state, fetched: false, fetching: true}                
        break;
    }
    case FETCH_PROPOSAL_PENDING:{                                             
        state = {...state, fetched: false, fetching: true}                
        break;
    }
    case FETCH_PROPOSAL_FULFILLED: {                           
        state = {...state, data: action.payload.data.reverse(), fetched: true, fetching: false}                
        break;
    }    
    case FETCH_PROPOSAL_REJECTED:{             
        state = {...state, data: action.payload.data, error : true, fetched: false, fetching: false}         
        break;
    }  

    case LOG_OUT: {        
        state = {...state, fetching: false, "fetched": false, data: []};   
        break;  
    }
    default:
        break;
  }
  return state;
}

export default proposals;



// WEBPACK FOOTER //
// ./src/reducers/proposals.js